import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Quantity from "./Quantity";
import "./Product.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { CAROUSEL_RESPONSIVE_CONFIG } from "../share/common";
import { useSelector } from "react-redux";

function Product() {
  const history = useHistory();
  const [product, setProduct] = useState(null);
  const slug = useParams().slug;
  console.log(slug);
  const recommendedProduct = useSelector((state) => state.recommendedProduct);

  useEffect(() => {
    //console.log("SLUG : ", slug);
    const url = process.env.REACT_APP_API_URL + `/products/${slug}`;
    const fetchData = async () => {
      const { data } = await axios({
        method: "GET",
        url: url,
      });
      setProduct(data);
    };
    fetchData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  return (
    <div>
      {product ? (
        <div className="container content">
          <div className="row mt-2">
            <div className="col-md-6 text-center p-3">
              <img
                className="contentImg img-fluid shadow rounded p-3"
                src={`${product.picture}`}
                alt={product.name}
              />
            </div>
            <div className="col-md-6">
              <div className="wine-product p-3">
                <h3>{product.name}</h3>
                <h4>$ {product.price}</h4>
                <p>{product.description}</p>

                <div className="d-flex align-items-center">
                  <Quantity product={product} />
                </div>
              </div>
              <hr />
              <span className="btn btn-secondary btn-sm mb-3" onClick={() => history.goBack()}>
                Volver
              </span>
              <Link to="/ver-pedido" className="btn btn-wine-finalizar btn-sm mb-3">
                Finalizar compra
              </Link>
              <div className="container">
                <Carousel
                  className="my-5"
                  responsive={CAROUSEL_RESPONSIVE_CONFIG}
                  infinite={true}
                  autoPlay={true}
                >
                  {recommendedProduct.map((recommended) => (
                    <Link
                      className="wine-container"
                      key={recommended.slug}
                      to={`/producto/${recommended.slug}`}
                      style={{height: '300px'}}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "200px", width: "100%" }}
                      >
                        <img
                          style={{ height: "80%" }}
                          src={`${recommended.picture}`}
                          alt={recommended.name}
                        />
                      </div>
                      {/* <img src={`${recommended.picture}`} alt={recommended.name} /> */}
                      <div className="d-flex flex-column justify-content-center carousel_wine text-center align-items-center pt-4">
                        <span>{recommended.name}</span>
                        <span>$ {recommended.price}</span>
                      </div>
                    </Link>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex vh-100 justify-content-center align-items-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>{" "}
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Product;
